import moment from 'moment'

/** Accounts created after this date can still be on the setup steps. */
export const ONBOARDING_CREATED_AFTER = '2025-06-01'

/**
 * True when this account still has the setup steps. Same rule as the setup page:
 * Transpond, created after 1 June 2025, and at least one onboarding step unfinished.
 * @param {object} accountState Redux accountMaster slice, or an object with progress and accountMaster
 * @param {number|string} siteId
 * @returns {boolean}
 */
export function isOnboardingInProgress(accountState, siteId) {
    if (Number(siteId) !== 1) return false
    const accountMaster = accountState?.accountMaster?.createdAt ? accountState.accountMaster : accountState
    const createdAt = accountMaster?.createdAt
    if (!createdAt || !moment(createdAt).isAfter(ONBOARDING_CREATED_AFTER)) return false
    const progress = accountState?.progress
    if (!progress || typeof progress !== 'object') return false
    let total = 1
    let finished = 1
    for (const key in progress) {
        total++
        if (progress[key]) finished++
    }
    return total !== finished
}
